
import { useState, useEffect, FormEvent } from 'react'
import { useApiClient } from '../lib/api-client'
import { useQueryClient } from '@tanstack/react-query'


interface RequestFormProps {
  editId?: string | null
  templateName?: string | null
  onSuccess: () => void
  onCancel?: () => void
}

function RequestForm({ editId, templateName, onSuccess, onCancel }: RequestFormProps) {
  const isEdit = !!editId
  const api = useApiClient()
  const queryClient = useQueryClient()

  const [formData, setFormData] = useState<Record<string, any>>({





    tripDate: '',





    destination: '',





    purpose: '',





    amount: '',





    remarks: '',





















  })


  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (editId) {
      api.get(`/businesstrips/${editId}`)
        .then(res => res.data.data ?? res.data)
        .then(data => {
          setFormData({





            tripDate: data.tripDate ?? '',





            destination: data.destination ?? '',





            purpose: data.purpose ?? '',





            amount: data.amount ?? '',





            remarks: data.remarks ?? '',





















          })

        })
        .catch(err => setError(err.message))
    }
  }, [editId])

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError(null)

    try {
      const payload: Record<string, any> = { ...formData }
      const response = isEdit
        ? await api.put(`/businesstrips/${editId}`, payload)
        : await api.post(`/businesstrips`, { ...payload, templateName: templateName || undefined })

      if (!response.data?.success) {
        const details = response.data?.error?.details
        if (Array.isArray(details) && details.length > 0) {
          throw new Error(details.map((e: any) => e.message || e).join('\n'))
        }
        throw new Error(response.data?.error?.message || (isEdit ? '更新に失敗しました' : '作成に失敗しました'))
      }

      await queryClient.invalidateQueries({ queryKey: ['businesstrips'] })
      onSuccess()
    } catch (err: any) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (field: string, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  return (
    <div className="request-form">
      <h2>{isEdit ? '申請を編集' : '新規申請'}</h2>
      {error && <div className="error">{error}</div>}

      <form onSubmit={handleSubmit}>




        <div className="form-group">
          <label htmlFor="tripDate">
            出張日
            <span className="required">*</span>
          </label>

          <input
            type="date"
            id="tripDate"
            data-testid="field-tripDate"
            value={formData.tripDate}
            onChange={(e) => handleChange('tripDate', e.target.value)}
            required
          />

        </div>



        <div className="form-group">
          <label htmlFor="destination">
            行き先
            <span className="required">*</span>
          </label>

          <input
            type="text"
            id="destination"
            data-testid="field-destination"
            value={formData.destination}
            onChange={(e) => handleChange('destination', e.target.value)}
            required
          />

        </div>



        <div className="form-group">
          <label htmlFor="purpose">
            目的
            <span className="required">*</span>
          </label>

          <textarea
            id="purpose"
            data-testid="field-purpose"
            value={formData.purpose}
            onChange={(e) => handleChange('purpose', e.target.value)}
            required
          />

        </div>



        <div className="form-group">
          <label htmlFor="amount">
            金額
            <span className="required">*</span>
          </label>

          <input
            type="number"
            id="amount"
            data-testid="field-amount"
            value={formData.amount}
            onChange={(e) => handleChange('amount', parseFloat(e.target.value))}
            required


            min="1"




          />

        </div>



        <div className="form-group">
          <label htmlFor="remarks">
            備考
            
          </label>

          <textarea
            id="remarks"
            data-testid="field-remarks"
            value={formData.remarks}
            onChange={(e) => handleChange('remarks', e.target.value)}
            
          />

        </div>






















        <div className="form-actions">
          <button type="submit" data-testid="form-submit" disabled={loading}>
            {loading ? (isEdit ? '更新中...' : '保存中...') : (isEdit ? '更新する' : '保存する')}
          </button>
          {onCancel && (
            <button type="button" onClick={onCancel} className="btn-cancel">キャンセル</button>
          )}
        </div>
      </form>
    </div>
  )
}

export default RequestForm